module.exports = __webpack_public_path__ + "img/modules.744410a5.png";